import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
//import diamond_icon from '../assets/images/diamond_icon.png';
import logoWithout from '../assets/images/logo-without-o.png';
import logo from '../assets/images/logo-pitch.png';

interface Props {
  value: number;
  id: string;
  type:string;
}

const GradientCircularProgress: React.FC<Props> = ({ value, id,type='' }) => {

  var newvalue= 100-value;
  return (
    <div className="circular-wrapper" style={{ position: "relative", width: 90, height: 90 }}>
     

      {/* Progress Bar */}
      <CircularProgressbar
        value={value}
        strokeWidth={5}
        styles={buildStyles({
          pathColor: `url(#gradient-${id})`, // 🔥 use gradient ID here
          trailColor: "#eee",
        })}
      />

      <div className='pos-re-mess circular-icon'>
         <img className='fade-img' src={logoWithout} width={70} alt="logo" />
        <img className='gold-img' src={logo} width={100} alt="logo" style={{
            WebkitMaskImage: 'linear-gradient(to bottom, transparent ' + newvalue + '%, black 0%, black 90%, transparent 100%)',
            maskImage: 'linear-gradient(to bottom, transparent ' + newvalue + '%, black 0%, black 90%, transparent 100%)'
         }} />
      </div>

      {/* Center Icon */}
      {/* <img
        src={diamond_icon}
        alt="icon"
        className="circular-icon"
        
      /> */}
       {/* SVG Gradient Definition */}
       <svg style={{ height: 0 }}>
        <defs>
          {type=='their_interest'?
          <linearGradient id={`gradient-${id}`} x1="1.5" y1="0" x2="0" y2="0">
          <stop offset="0%" stopColor="#FFFACD" />   {/* Very light yellow */}
          <stop offset="50%" stopColor="#FFE873" />  {/* Light yellow */}
          <stop offset="100%" stopColor="#FFC107" /> {/* Dark yellow */}
        </linearGradient>

          :
        <linearGradient id={`gradient-${id}`} x1="1.5" y1="0" x2="0" y2="0">
            <stop offset="0%" stopColor="#edd656" />        {/* Yellow */}
            <stop offset="50%" stopColor="#FF7F50" />       {/* Light Red */}
            <stop offset="100%" stopColor="#FF2400" />      {/* Scarlet Red */}
          </linearGradient>}
        </defs>
      </svg>
    </div>
  );
};

export default GradientCircularProgress;
